import { useEffect, useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import classNames from "classnames";

import type { CopilotReasoning, CopilotToolCall } from "./types";
import ToolCallList from "./ToolCallList";
import styles from "./styles.module.scss";

const ActivityBlock = ({
  reasoning,
  tools,
}: {
  reasoning?: CopilotReasoning;
  tools: CopilotToolCall[];
}) => {
  const active =
    Boolean(reasoning?.active) ||
    tools.some(
      (tool) => tool.status === "pending" || tool.status === "running"
    );
  const [expanded, setExpanded] = useState(active);
  const [interacted, setInteracted] = useState(false);

  useEffect(() => {
    setExpanded(active);
  }, [active]);

  const seconds =
    reasoning?.durationMs != null
      ? Math.max(1, Math.round(reasoning.durationMs / 1000))
      : null;
  const summary = active
    ? tools.some((tool) => tool.status === "running")
      ? "Using tools"
      : "Thinking"
    : [
        seconds != null
          ? `Thought for ${seconds} second${seconds === 1 ? "" : "s"}`
          : "Activity",
        tools.length
          ? `${tools.length} tool${tools.length === 1 ? "" : "s"}`
          : null,
      ]
        .filter(Boolean)
        .join(", ");

  return (
    <div className={styles.activity}>
      <button
        type="button"
        className={classNames(styles.activitySummary, {
          [styles.activitySummaryActive]: active,
        })}
        aria-expanded={expanded}
        onClick={() => {
          setInteracted(true);
          setExpanded((value) => !value);
        }}
      >
        <span>{summary}</span>
        <RightOutlined
          className={classNames(styles.activityChevron, {
            [styles.activityChevronExpanded]: expanded,
            [styles.activityChevronVisible]: interacted,
          })}
        />
      </button>
      {expanded && (
        <div className={styles.activityDetails}>
          {reasoning?.content.trim() && (
            <div className={styles.activityReasoningBody}>
              {reasoning.content}
            </div>
          )}
          {tools.length > 0 && <ToolCallList tools={tools} />}
        </div>
      )}
    </div>
  );
};

export default ActivityBlock;
